<div 
  aria-label="Banner section"
  class="tw-px-3.75 tw-bg-yellow-100 tw-h-[80px] tw-shadow-default tw-fixed tw-left-0 tw-top-0 tw-right-0 tw-z-[1000]">
  <div class="scoot-container tw-h-17.5 tw-mx-auto">
    <app-header-items></app-header-items>
  </div>
</div>